import * as z from 'zod'

import { BaseSchema_DogLiabilityV1GetsafeDe } from '@flows/insurance/schemas'

export const dogListSchema = z.object({
  name: BaseSchema_DogLiabilityV1GetsafeDe.shape.dogs.element.shape.name.unwrap(),
  breed_type: BaseSchema_DogLiabilityV1GetsafeDe.shape.dogs.element.shape.breed_type,
  breeds: BaseSchema_DogLiabilityV1GetsafeDe.shape.dogs.element.shape.breeds.default([]),
})
